import { spacing, color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
import { baseInputChoice, baseInputChoiceWrapper } from "./_base.js";
const classNamePrefix = "umd-field-radio";
const radio = {
  ...baseInputChoice,
  borderRadius: "50%",
  border: `1px solid ${color.gray.light}`,
  "&::after": {
    content: "''",
    backgroundSize: "contain",
    backgroundColor: color.red,
    backgroundPosition: "center",
    border: `1px solid ${color.gray.light}`,
    borderRadius: "50%",
    display: "block",
    height: spacing.xs,
    opacity: 0,
    position: "absolute",
    left: "5px",
    top: "5px",
    transition: "opacity 0.5s ease-in-out",
    visibility: "hidden",
    width: spacing.xs
  }
};
const radioWrapper = objectWithClassName({
  ...baseInputChoiceWrapper,
  className: [
    `${classNamePrefix}-wrapper`,
    /** @deprecated Use 'umd-field-radio-wrapper' instead */
    "umd-forms-choices-wrapper"
  ],
  "& input[type='radio']": {
    ...radio
  }
});
export {
  radio,
  radioWrapper
};
//# sourceMappingURL=radio.js.map
